import IframeActivity from "./IframeActivity";

export default function HouseAlwaysWins() {
    return (
        <IframeActivity
            src="/activities/house-always-wins/index.html"
            title="House Always Wins"
        />
    );
}